import { Box, Flex } from 'theme-ui'
import { TeachingLocation } from 'types/location'
import { getFromLocalizedString } from 'utils/getFromLocalizedString'

export const LocationSearchResult = ({
  item,
  onClick,
}: {
  item: TeachingLocation
  onClick: (item: TeachingLocation) => void
}) => {
  const { name = '', addressLine = '', zip = '', city = '', state = '' } = item
  const handleClick = () => {
    onClick(item)
  }

  return (
    <Flex variant="layout.result.locationSearch" sx={{}} onClick={handleClick}>
      <Box
        sx={{
          fontSize: 16,
          fontWeight: 600,
          flex: ['0 0 90%', '0 0 43%'],
        }}
      >
        {getFromLocalizedString(name)}
      </Box>
      <Box
        sx={{
          flex: ['0 0 90%', '0 0 56%'],
          color: 'gray',
        }}
      >
        {`${addressLine}, ${city}${state ? ', ' : ''}${state}${
          zip ? ' - ' : ''
        }${zip}`}
      </Box>
    </Flex>
  )
}
